import _objectWithoutProperties from "/Users/oct16/work/Cat/timecat-issue-helper/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default (function (_ref) {
  var components = _ref.components,
      props = _objectWithoutProperties(_ref, ["components"]);

  return /*#__PURE__*/React.createElement(MDXTag, {
    name: "wrapper",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "\u63CF\u8FF0\u4E00\u4E0B\u4F60\u671F\u671B\u8FD9\u4E2A\u65B0\u529F\u80FD\u7684 API \u662F\u5982\u4F55\u4F7F\u7528\u7684\uFF0C\u5E76\u63D0\u4F9B\u4E00\u4E9B\u4EE3\u7801\u793A\u4F8B\u3002\u8BF7\u7528 ", /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "p",
    props: {
      "href": "https://guides.github.com/features/mastering-markdown/"
    }
  }, "Markdown"), " \u683C\u5F0F\u5316\u4F60\u7684\u4EE3\u7801\u7247\u6BB5\u3002"));
});